import Header from "../HomePage/header";
import Footer from "../HomePage/footer";
import { Button } from "@/projects/NPS/Stepper/common/button";
import { useNavigate, useLocation } from "react-router-dom";
import { navigationRoutes } from "@/utils/routes";
import { Registration } from "@/utils/types/NPS/Stepper/GetRegistrationDetils";
import { useEffect, useRef, useState } from "react";
import GetPensionFundManagerService from "@/services/NPS/Stepper/APIs/GetPensionFundManagerService";
import Loader from "@/projects/NPS/Stepper/common/Loader";
import { PfmNameId } from "@/utils/types/NPS/Stepper/PensionFundManager";
import CommonModal from "@/projects/NPS/Stepper/common/Modal";
import UPIPaymentModal from "@/projects/NPS/Stepper/common/UPIPaymentModal";
import PaymentStatusModal from "@/projects/NPS/Stepper/components/PaymentStatusModal";
import GetRegistrationDetailsService from "@/services/NPS/Stepper/APIs/getRegistrationDetailsService";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const formatDate = (dateStr: string | undefined): string => {
  if (!dateStr || dateStr.length !== 8) {
    return "--";
  }
  const day = dateStr.substring(0, 2);
  const month = dateStr.substring(2, 4);
  const year = dateStr.substring(4, 8);
  return `${day}/${month}/${year}`;
};

const formatCurrency = (value: string | number | undefined): string => {
  if (value === undefined || value === null || value === "") {
    return "--";
  }
  const num = typeof value === "string" ? parseFloat(value) : value;
  return `Rs. ${num.toFixed(2)}`;
};

const getGenderLabel = (code: string | undefined): string => {
  const genderMap: Record<string, string> = {
    M: "Male",
    F: "Female",
    T: "Transgender",
  };
  return genderMap[code ?? ""] ?? "--";
};

const getMaritalStatusLabel = (code: string | undefined): string => {
  const maritalMap: Record<string, string> = {
    M: "Married",
    U: "Unmarried",
    D: "Divorced",
    W: "Widow/Widower",
  };
  return maritalMap[code ?? ""] ?? "--";
};

const getRelationshipLabel = (code: string | undefined): string => {
  const relationshipMap: Record<string, string> = {
    "01": "Father",
    "02": "Mother",
    "03": "Spouse",
    "04": "Brother",
    "05": "Sister",
    "06": "Other",
  };
  return relationshipMap[code ?? ""] ?? "--";
};

const getMajorMinorLabel = (code: string | undefined): string => {
  const majorMinorMap: Record<string, string> = {
    Y: "Major",
    N: "Minor",
  };
  return majorMinorMap[code ?? ""] ?? "--";
};

const getPepLabel = (code: string | undefined): string => {
  const pepMap: Record<string, string> = {
    "01": "Yes",
    "02": "No",
  };
  return pepMap[code ?? ""] ?? "--";
};

const getPranModeLabel = (code: string | undefined): string => {
  const pranModeMap: Record<string, string> = {
    "1": "DIGITAL PRAN CARD & WELCOME KIT (CHARGES RS 18/-)",
    "2": "DIGITAL PRAN CARD & PHYSICAL WELCOME KIT (CHARGES RS 35/-)",
    "3": "PHYSICAL PRAN CARD & WELCOME KIT (CHARGES RS 40/-)",
  };
  return pranModeMap[code ?? ""] ?? "--";
};

const getIncomeRangeLabel = (code: string | undefined): string => {
  const incomeRangeMap: Record<string, string> = {
    "01": "< ₹1 Lakh",
    "02": "₹1–5 Lakh",
    "03": "₹5–10 Lakh",
    "04": "₹10–20 Lakh",
    "05": "₹20–50 Lakh",
  };
  return incomeRangeMap[code ?? ""] ?? "--";
};

const getOccupationLabel = (code: string | undefined): string => {
  const occupationMap: Record<string, string> = {
    "01": "Public Sector",
    "02": "Private Sector",
    "03": "Self Employed",
    "04": "Professional",
    "05": "Homemaker",
    "06": "Others",
  };
  return occupationMap[code ?? ""] ?? "--";
};

const SubscriberRegistrationSummary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const summaryRef = useRef<HTMLDivElement>(null);
  const ReferenceResponse = location.state?.RegistrationDetails as
    | Registration
    | undefined;
  const [registrationDetails, setRegistrationDetails] =
    useState<Registration | null>(ReferenceResponse ?? null);
  const [fundManager, setFundManager] = useState("");
  const [investmentChoice, setInvestmentChoice] = useState("");
  const [allocations, setAllocations] = useState<Record<string, number>>({});
  const [schemeOptions, setSchemeOptions] = useState<any[]>([]);
  const [isLoadingSchemes, setIsLoadingSchemes] = useState(false);
  const [fundManagerOptions, setFundManagerOptions] =
    useState<PfmNameId | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [paypointzPaymentId, setPaypointzPaymentId] = useState("");
  const [ackId, setAckId] = useState("");
  useEffect(() => {
    setAckId(registrationDetails?.initialDetails?.ackId ?? "");
    setPaypointzPaymentId(
      registrationDetails?.personalDtls?.paypointz_payment ?? ""
    );
    console.log(
      "Registration Details received in Summary:",
      registrationDetails
    );
  }, [registrationDetails]);

  useEffect(() => {
    const fetchRegistrationDetails = async () => {
      setIsLoading(true);
      try {
        const response =
          await GetRegistrationDetailsService.getRegistrationDetails();
        if (response.success) {
          setRegistrationDetails(response.registration);
          setIsLoading(false);
        } else {
          console.error("Failed to fetch registration details.");
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching registration details:", error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };
    fetchRegistrationDetails();
  }, []);

  useEffect(() => {
    const fetchPensionFundManager = async () => {
      const response =
        await GetPensionFundManagerService.getPensionFundManager();
      if (response?.pfms?.pfmNameId) {
        setFundManagerOptions(response.pfms.pfmNameId);

        // ✅ Auto-select the first PFM
        const firstPfmId = Object.keys(response.pfms.pfmNameId)[0];
        if (firstPfmId && !fundManager) {
          setFundManager(firstPfmId);
        }
      }
    };
    fetchPensionFundManager();
  }, [fundManager]);

  useEffect(() => {
    if (fundManager) {
      const fetchSchemes = async () => {
        setIsLoadingSchemes(true);
        try {
          const response =
            await GetPensionFundManagerService.getSchemeByPfmId(fundManager);
          if (response.success && response.options) {
            setSchemeOptions(response.options);

            // Only update allocations if they haven't been set already
            const initAllocations: Record<string, number> = {};
            response.options.forEach((opt: any) => {
              // Initialize the allocations only if the value is not already set
              if (!(opt.value in allocations)) {
                initAllocations[opt.value] = 0;
              } else {
                initAllocations[opt.value] = allocations[opt.value];
              }
            });

            // Set the allocations only if there was any change
            setAllocations(prevAllocations => {
              // Only update allocations if they are different from the current state
              const allocationsChanged = Object.keys(initAllocations).some(
                key => initAllocations[key] !== prevAllocations[key]
              );

              return allocationsChanged ? initAllocations : prevAllocations;
            });
          } else {
            setSchemeOptions([]);
            setAllocations({});
          }
        } catch (error) {
          console.error("Failed to fetch schemes", error);
          setSchemeOptions([]);
          setAllocations({});
        } finally {
          setIsLoadingSchemes(false);
        }
      };

      fetchSchemes();
    } else {
      setSchemeOptions([]);
      setAllocations({});
    }
  }, [fundManager, allocations]);

  useEffect(() => {
    if (
      registrationDetails?.schemeDtls &&
      registrationDetails?.schemeDtls.length > 0
    ) {
      const uniquePfmIds = new Set(
        registrationDetails?.schemeDtls[0]?.schemeList?.map(
          (item: any) => item.pfmId
        )
      );

      // Convert Set back to a comma-separated string
      const pfmIds = Array.from(uniquePfmIds).join(",");
      setFundManager(pfmIds);

      setInvestmentChoice(
        registrationDetails?.schemeDtls[0]?.schPrefChoice === "B"
          ? "Balanced Life Cycle"
          : registrationDetails?.schemeDtls[0]?.schPrefChoice === "A"
            ? "Auto"
            : "Active"
      );

      // Initialize the allocations with the schemePercentage from schemeList
      setAllocations(
        registrationDetails?.schemeDtls[0]?.schemeList?.reduce(
          (acc: Record<string, number>, item: any) => {
            acc[item.schemeId] = parseFloat(item.schemePercentage); // Set the schemePercentage value here
            return acc;
          },
          {}
        )
      );
    }
  }, [registrationDetails]);

  const handleClosePayModal = () => {
    setShowPayModal(false);
  };
  const handleCloseStatusModal = () => {
    setOpenStatusModal(false);
  };

  const handlePreviewPay = async () => {
    if (paypointzPaymentId) {
      setOpenStatusModal(true);
    } else {
      setShowPayModal(true);
    }
  };

  const handleBack = () => {
    navigate(navigationRoutes.NEW_SUBSCRIBER_REGISTRATION);
  };
  const nominees = registrationDetails?.nominationDtls ?? [];
  const firstBank = Array.isArray(registrationDetails?.bankDtls)
    ? registrationDetails?.bankDtls[0]
    : registrationDetails?.bankDtls;

  const renderSchemeDetails = () => {
    const schemeList = schemeOptions || [];
    return schemeList.map((scheme: any) => (
      <div key={scheme.schemeId} className="mt-2 flex">
        <div className="flex w-[50%] gap-3">
          <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
            Scheme Name
          </p>
          <p className="font-nunito text-base font-semibold text-[#2F363F]">
            : -
          </p>
          <p className="font-nunito text-base font-semibold text-[#707070]">
            {scheme.label ?? "--"}
          </p>
        </div>
        <div className="flex w-[50%] gap-3">
          <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
            Scheme Percentage
          </p>
          <p className="font-nunito text-base font-semibold text-[#2F363F]">
            : -
          </p>
          <p className="font-nunito text-base font-semibold text-[#707070]">
            {allocations[scheme.value] ? `${allocations[scheme.value]}%` : "--"}
          </p>
        </div>
      </div>
    ));
  };

  const renderNomineeDetails = (nominee: any, index: number) => {
    return (
      <div key={index} className="mb-4 last:mb-0">
        <h3 className="mb-2 font-nunito text-lg font-bold text-[#266985]">
          Nominee Details - {index + 1}
        </h3>
        <div className="flex">
          <div className="flex w-[100%] gap-3">
            <p className="w-[17%] font-nunito text-base font-semibold text-[#2F363F]">
              Full Name
            </p>
            <p className="font-nunito text-base font-semibold text-[#2F363F]">
              : -
            </p>
            <p className="font-nunito text-base font-semibold text-[#707070]">
              {nominee
                ? (`${nominee.firstName ?? ""} ${nominee.middleName ?? ""} ${nominee.lastName ?? ""}`.trim() ??
                  "--")
                : "--"}
            </p>
          </div>
        </div>
        <div className="mt-2 flex">
          <div className="flex w-[50%] gap-3">
            <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
              Relationship
            </p>
            <p className="font-nunito text-base font-semibold text-[#2F363F]">
              : -
            </p>
            <p className="font-nunito text-base font-semibold text-[#707070]">
              {getRelationshipLabel(nominee?.relationship)}
            </p>
          </div>
          <div className="flex w-[50%] gap-3">
            <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
              Major/Minor
            </p>
            <p className="font-nunito text-base font-semibold text-[#2F363F]">
              : -
            </p>
            <p className="font-nunito text-base font-semibold text-[#707070]">
              {getMajorMinorLabel(
                (nominee as any)?.majorMinorFlag ?? nominee?.majorMinor
              )}
            </p>
          </div>
        </div>
        <div className="mt-2 flex">
          <div className="flex w-[50%] gap-3">
            <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
              Nominee Age (Year)
            </p>
            <p className="font-nunito text-base font-semibold text-[#2F363F]">
              : -
            </p>
            <p className="font-nunito text-base font-semibold text-[#707070]">
              {(nominee as any)?.nomineeAge ?? nominee?.age ?? "--"}
            </p>
          </div>
          <div className="flex w-[50%] gap-3">
            <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
              Nominee Percentage
            </p>
            <p className="font-nunito text-base font-semibold text-[#2F363F]">
              : -
            </p>
            <p className="font-nunito text-base font-semibold text-[#707070]">
              {(nominee as any)?.percentageShare
                ? `${(nominee as any).percentageShare}%`
                : "--"}
            </p>
          </div>
        </div>
        {(nominee as any)?.majorMinorFlag === "Y" ||
        nominee?.majorMinor === "Y" ? (
          <div className="mt-2 flex">
            <div className="flex w-[100%] gap-3">
              <p className="w-[17%] font-nunito text-base font-semibold text-[#2F363F]">
                Guardian Name
              </p>
              <p className="font-nunito text-base font-semibold text-[#2F363F]">
                : -
              </p>
              <p className="font-nunito text-base font-semibold text-[#707070]">
                {nominee
                  ? (`${(nominee as any).guardianFirstName ?? ""} ${(nominee as any).guardianMiddleName ?? ""} ${(nominee as any).guardianLastName ?? ""}`.trim() ??
                    "--")
                  : "--"}
              </p>
            </div>
          </div>
        ) : null}
      </div>
    );
  };
  const downloadPDF = async () => {
    const input = summaryRef.current;
    if (!input) {
      return;
    }

    // Step 1: Convert summary to canvas
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
    });

    // Step 2: Convert to PDF with A4 size and proper padding
    const imgData = canvas.toDataURL("image/png");

    // A4 dimensions in mm
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm

    // Set margins (default padding: 10mm on all sides)
    const marginLeft = 10;
    const marginRight = 10;
    const marginTop = 10;
    const marginBottom = 10;

    // Calculate available width and height for content
    const contentWidth = pageWidth - marginLeft - marginRight; // 190mm
    const contentHeight = pageHeight - marginTop - marginBottom; // 277mm

    // Calculate image dimensions to fit within margins while maintaining aspect ratio
    const imgWidth = contentWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = marginTop;

    // Add first page
    pdf.addImage(imgData, "PNG", marginLeft, position, imgWidth, imgHeight);
    heightLeft -= contentHeight;

    // Add additional pages if content is longer than one page
    while (heightLeft > 0) {
      position = -contentHeight + heightLeft;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", marginLeft, position, imgWidth, imgHeight);
      heightLeft -= contentHeight;
    }

    pdf.save("Subscriber_Summary.pdf");
  };
  return (
    <>
      <style>
        {`
          @media print {
            .print-format {
              width: 100px;
            }
          }
        `}
      </style>
      {isLoading && <Loader message="Checking payment status..." />}
      <Header />
      <div className="container mx-auto px-4 py-12 lg:px-10 xl:px-10 2xl:px-0">
        <div className="flex items-center justify-between">
          <h1 className="mb-12 text-center font-nunito text-lg font-semibold text-[#266985] md:text-left md:text-[34px]">
            Subscriber Registration Summary
          </h1>
          <Button
            type="button"
            onClick={downloadPDF}
            className="h-[50px] rounded-md bg-gradient-to-r from-[#127B8D] to-[#10B981] px-10 py-2 font-nunito text-[18px] font-semibold text-white transition hover:opacity-95"
          >
            Download PDF
          </Button>
        </div>
        <div
          ref={summaryRef}
          id="summary-to-print"
          className="summary-section mx-auto max-w-[] space-y-3 overflow-x-auto"
        >
          {/* KYC Details */}
          <div className="rounded-lg border border-[#707070] p-2">
            <div className="summary-title rounded-lg bg-[#E4FFFB] px-4 py-2">
              <h2 className="font-nunito text-xl font-bold">KYC Details</h2>
            </div>
            <div className="p-2">
              <div className="flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Permanent Account Number (PAN)
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.pan ?? "--"}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Full Name(As per PAN Card)
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.subFstName ?? "--"}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Date of Birth (DD/MM/YYYY)
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {formatDate(registrationDetails?.personalDtls?.subDob) ??
                      "--"}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Mobile Number
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.mobile ??
                      registrationDetails?.initialDetails?.user?.phone_number ??
                      "--"}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Email ID
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.email ??
                      registrationDetails?.initialDetails?.user?.email ??
                      "--"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-lg border border-[#707070] p-2">
            <div className="summary-title rounded-lg bg-[#E4FFFB] px-4 py-2">
              <h2 className="font-nunito text-xl font-bold">
                Personal Details
              </h2>
            </div>
            <div className="p-2">
              <div className="grid grid-cols-[1fr_auto] items-center gap-4 border-b border-[#DFE7EC] pb-3">
                <div className="space-y-2">
                  <div className="flex gap-3">
                    <p className="w-[25%] font-nunito text-base font-semibold text-[#2F363F]">
                      Full Name
                    </p>
                    <p className="font-nunito text-base font-semibold text-[#2F363F]">
                      : -
                    </p>
                    <p className="font-nunito text-base font-semibold text-[#707070]">
                      {registrationDetails?.personalDtls?.subFstName ?? "--"}
                    </p>
                  </div>
                  <div className="flex gap-3">
                    <p className="w-[25%] font-nunito text-base font-semibold text-[#2F363F]">
                      Address
                    </p>
                    <p className="font-nunito text-base font-semibold text-[#2F363F]">
                      : -
                    </p>
                    <p className="flex-1 font-nunito text-base font-semibold text-[#707070]">
                      {[
                        registrationDetails?.personalDtls?.pAddrLine1,
                        registrationDetails?.personalDtls?.pAddrLine2,
                        registrationDetails?.personalDtls?.pAddrLine3,
                      ]
                        .filter(part => !!part)
                        .join(" ") ?? "--"}
                    </p>
                  </div>
                  <div className="flex gap-3">
                    <p className="w-[25%] font-nunito text-base font-semibold text-[#2F363F]">
                      Birth Date
                    </p>
                    <p className="font-nunito text-base font-semibold text-[#2F363F]">
                      : -
                    </p>
                    <p className="flex-1 font-nunito text-base font-semibold text-[#707070]">
                      {formatDate(registrationDetails?.personalDtls?.subDob)}
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <div className="flex h-[120px] w-[120px] items-center justify-center rounded-lg border-2 border-[#DFE7EC] bg-gray-50">
                    {registrationDetails?.personalDtls?.pPhotoText ? (
                      <img
                        src={`data:image/png;base64,${registrationDetails.personalDtls.pPhotoText}`}
                        alt="User"
                        className="h-full w-full rounded-lg object-cover"
                        onError={e => {
                          e.currentTarget.style.display = "none";
                          e.currentTarget.nextElementSibling?.classList.remove(
                            "hidden"
                          );
                        }}
                      />
                    ) : (
                      <img
                        src="/assets/image.png"
                        alt="User"
                        className="h-full w-full rounded-lg object-cover"
                        onError={e => {
                          e.currentTarget.style.display = "none";
                          e.currentTarget.nextElementSibling?.classList.remove(
                            "hidden"
                          );
                        }}
                      />
                    )}
                    <div className="hidden text-sm text-gray-400">No Image</div>
                  </div>
                </div>
              </div>

              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Gender
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {getGenderLabel(registrationDetails?.personalDtls?.gender)}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Marital Status
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {getMaritalStatusLabel(
                      registrationDetails?.personalDtls?.maritalStatus
                    )}
                  </p>
                </div>
              </div>

              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Spouse&apos;s Name
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.spouseFirstName ?? "--"}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Residential Status
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.countryOfResidence ===
                    "IN"
                      ? "Indian Resident"
                      : (registrationDetails?.personalDtls
                          ?.countryOfResidence ?? "--")}
                  </p>
                </div>
              </div>

              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Place of Birth
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.placeOfBirth ?? "--"}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Country of Birth
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.countryOfBirth === "IN"
                      ? "Indian"
                      : (registrationDetails?.personalDtls?.countryOfBirth ??
                        "--")}
                  </p>
                </div>
              </div>

              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Nationality
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {((registrationDetails?.personalDtls as any)?.nationality ??
                      "--") === "IN"
                      ? "Indian"
                      : ((registrationDetails?.personalDtls as any)
                          ?.nationality ?? "--")}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Occupation
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {getOccupationLabel(
                      registrationDetails?.personalDtls?.occupation
                    ) ?? "--"}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Please Select If Other
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {registrationDetails?.personalDtls?.otherOccDetails ?? "--"}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Income Range (Per annum)
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {getIncomeRangeLabel(
                      registrationDetails?.personalDtls?.incomeRange
                    ) ?? "--"}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Are you Politically Exposed Person?
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {getPepLabel(
                      registrationDetails?.personalDtls?.politicallyExposed
                    )}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    I would like to receive my PRAN as
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {getPranModeLabel(
                      registrationDetails?.personalDtls?.epranWelcomePran
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-lg border border-[#707070] p-2">
            <div className="summary-title rounded-lg bg-[#E4FFFB] px-4 py-2">
              <h2 className="font-nunito text-xl font-bold">Nominee Details</h2>
            </div>
            <div className="p-2">
              {nominees.length > 0 ? (
                nominees.map((nominee: any, index: number) =>
                  renderNomineeDetails(nominee, index)
                )
              ) : (
                <p className="font-nunito text-base font-semibold text-[#707070]">
                  No nominee details available
                </p>
              )}
            </div>
          </div>
          <div className="rounded-lg border border-[#707070] p-2">
            <div className="summary-title rounded-lg bg-[#E4FFFB] px-4 py-2">
              <h2 className="font-nunito text-xl font-bold">Bank Details</h2>
            </div>
            <div className="p-2">
              <div className="flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Account Type
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {firstBank?.accountType ?? "--"}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Bank A/C Number
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {firstBank?.bankAccountNumber ?? "--"}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex">
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Bank IFSC Code
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {firstBank?.bankIfsCode ?? "--"}
                  </p>
                </div>
                <div className="flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Bank Name
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {firstBank?.bankName ?? "--"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Scheme Details */}
          <div className="rounded-lg border border-[#707070] p-2">
            <div className="summary-title rounded-lg bg-[#E4FFFB] px-4 py-2">
              <h2 className="font-nunito text-xl font-bold">
                Investment Options
              </h2>
            </div>
            {isLoadingSchemes ? (
              <div className="flex h-full items-center justify-center">
                <Loader message="Loading Summary details..." />
              </div>
            ) : (
              <>
                <div className="ml-2 mt-2 flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Fund Manager
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {fundManagerOptions?.[fundManager as keyof PfmNameId] ??
                      "--"}
                  </p>
                </div>
                <div className="ml-2 mt-2 flex w-[50%] gap-3">
                  <p className="w-[35%] font-nunito text-base font-semibold text-[#2F363F]">
                    Investment Choice
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {investmentChoice ?? "--"}
                  </p>
                </div>
                <div className="mx-2">
                  {/* Render Scheme List */}
                  {renderSchemeDetails()}
                </div>
              </>
            )}
          </div>
          <div className="rounded-lg border border-[#707070] p-2">
            <div className="summary-title rounded-lg bg-[#E4FFFB] px-4 py-2">
              <h2 className="font-nunito text-xl font-bold">Payment Details</h2>
            </div>
            <div className="p-2">
              <div className="flex">
                <div className="flex w-[100%] gap-3">
                  <p className="w-[50%] font-nunito text-base font-semibold text-[#2F363F]">
                    PRAN Total Contribution
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {formatCurrency(
                      registrationDetails?.personalDtls?.pran_total_contribution
                    )}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex">
                <div className="flex w-[100%] gap-3">
                  <p className="w-[50%] font-nunito text-base font-semibold text-[#2F363F]">
                    PRAN Account Opening Charges
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {formatCurrency(
                      registrationDetails?.personalDtls?.pran_ac_opening_charges
                    )}
                  </p>
                </div>
              </div>
              <div className="mt-2 flex">
                <div className="flex w-[100%] gap-3">
                  <p className="w-[50%] font-nunito text-base font-semibold text-[#2F363F]">
                    PRAN Account Opening Charges (GST 18%)
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {formatCurrency(
                      registrationDetails?.personalDtls
                        ?.pran_ac_opening_charges_gst
                    )}
                  </p>
                </div>
              </div>
              <div className="">
                <div className="mt-1 flex w-[100%] gap-3">
                  <p className="w-[50%] font-nunito text-base font-semibold text-[#2F363F]">
                    Total Payable Amount
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#2F363F]">
                    : -
                  </p>
                  <p className="font-nunito text-base font-semibold text-[#707070]">
                    {formatCurrency(
                      registrationDetails?.personalDtls?.total_payable_amount
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-center gap-3 sm:justify-end md:gap-5">
          <Button
            type="button"
            onClick={handleBack}
            className="h-[50px] rounded-md bg-gradient-to-r from-[#127B8D] to-[#10B981] px-10 py-2 font-nunito text-[18px] font-semibold text-white transition hover:opacity-95"
          >
            Back
          </Button>
          <Button
            // disabled={!isTermsAccepted}
            type="button"
            onClick={handlePreviewPay}
            className={`ounded-md h-[50px] w-[180px] cursor-pointer rounded-md bg-gradient-to-r from-[#127B8D] to-[#10B981] py-2 font-nunito text-[18px] font-semibold tracking-[1px] text-white hover:opacity-95`}
          >
            Pay
          </Button>
        </div>
      </div>
      {showPayModal && (
        <CommonModal
          isOpen={showPayModal}
          onClose={handleClosePayModal}
          width="w-full sm:w-[900px]"
          height="h-auto"
          padding="p-2 sm:p-6"
        >
          <UPIPaymentModal
            key={registrationDetails ? "loaded" : "loading"}
            amount={Number(
              registrationDetails?.personalDtls?.total_payable_amount ?? 0
            )}
            ackId={ackId}
            registrationDetails={registrationDetails}
            summary={{
              pran_total_contribution: Number(
                registrationDetails?.personalDtls?.pran_total_contribution ?? 0
              ),
              pran_ac_opening_charges: Number(
                registrationDetails?.personalDtls?.pran_ac_opening_charges ?? 0
              ),
              pran_ac_opening_charges_gst: Number(
                registrationDetails?.personalDtls
                  ?.pran_ac_opening_charges_gst ?? 0
              ),
              total_payable_amount: Number(
                registrationDetails?.personalDtls?.total_payable_amount ?? 0
              ),
            }}
          />
        </CommonModal>
      )}
      {openStatusModal && (
        <CommonModal isOpen={openStatusModal} onClose={handleCloseStatusModal}>
          <PaymentStatusModal
            ackId={ackId}
            amount={Number(
              registrationDetails?.personalDtls?.total_payable_amount ?? 0
            )}
            setPaypointzPaymentId={setPaypointzPaymentId}
            paypointzPaymentId={paypointzPaymentId}
            summary={{
              pran_total_contribution: Number(
                registrationDetails?.personalDtls?.pran_total_contribution ?? 0
              ),
              pran_ac_opening_charges: Number(
                registrationDetails?.personalDtls?.pran_ac_opening_charges ?? 0
              ),
              pran_ac_opening_charges_gst: Number(
                registrationDetails?.personalDtls
                  ?.pran_ac_opening_charges_gst ?? 0
              ),
              total_payable_amount: Number(
                registrationDetails?.personalDtls?.total_payable_amount ?? 0
              ),
            }}
            onClose={() => setOpenStatusModal(false)}
          />
        </CommonModal>
      )}
      <Footer />
    </>
  );
};

export default SubscriberRegistrationSummary;
